<template>
    <div
        class="loja-perfeita-form-control-loading-wrap position-relative w-100"
        :class="{ 'loja-perfeita-form-control-loading-wrap--busy': busy }"
    >
        <slot />
        <b-spinner
            v-if="busy"
            small
            variant="primary"
            class="loja-perfeita-form-control-loading-wrap__spinner"
            :aria-label="spinnerLabel"
        />
    </div>
</template>

<script>
import Shared from '@src/mixins/shared.vue'

const i18nKey = 'LOJA_PERFEITA'

export default {
    name: 'LojaPerfeitaFormControlLoadingWrap',
    mixins: [Shared],
    props: {
        busy: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        spinnerLabel() {
            return this.getI18n(i18nKey, 'MESSAGES.loading_field') || 'Loading…'
        },
    },
}
</script>

<style scoped>
/* Room for native select chevron (~1rem) + spinner (~1rem) inside the control */
.loja-perfeita-form-control-loading-wrap--busy ::v-deep select.custom-select,
.loja-perfeita-form-control-loading-wrap--busy ::v-deep select.form-control {
    padding-right: 3rem;
}

.loja-perfeita-form-control-loading-wrap__spinner {
    position: absolute;
    top: 50%;
    right: 2rem;
    margin-top: -0.5rem;
    pointer-events: none;
}
</style>
